export default "__VITE_ASSET__6e5ac406__"